import {AdminRole, } from './middleware/roles'

import Home from '../views/Home'
import Products from '../views/products/Products'
import ProductCreate from '../views/products/ProductCreate'
import ProductDetails from '../views/products/ProductDetails'
import Attributes from '../views/products/Attributes'
import Testers from '../views/testers/Testers'
import Defects from '../views/defects/Defects'




export default [
    {path: '/', name: 'home', component: Home},
    // no touchy touchy
    {path: '/callback', name: 'cb', component: Home},
    //
    {path: '/products', name: 'products', component: Products, meta: {hasAcces: AdminRole}},
    {path: '/products/create', props: true, name: 'product-create', component: ProductCreate, meta: {hasAcces: AdminRole}},
    {path: '/products/attributes', name: 'product-attributes', component: Attributes, meta: {hasAcces: AdminRole}},
    {path: '/products/:id', props: true, name: 'product-details', component: ProductDetails, meta: {hasAcces: AdminRole}},
    {path: '/testers', name: 'testers', component: Testers, meta: {hasAcces: AdminRole}},
    {path: '/defects', name: 'defects', component: Defects, meta: {hasAcces: AdminRole}},

    {path: '/exports', name: 'export',  component: () => import(/* webpackChunkName: "admin" */ '../views/exports/Exports.vue'), meta: {hasAcces: AdminRole}},
 ]
